class Profile
{
    /**
     * Create a new session instance.
     * 
     * @return void
     */
    constructor()
    {
        let _profile = localStorage.getItem("_profile");

        this.profileExists = _profile != null && _profile !== undefined;

        if(this.profileExists) {
            this.profile = JSON.parse(_profile);
        }
    }

    /**
     * Checks whether the session exists in local storage or not.
     * 
     * @return {Boolean}
     */
    exists()
    {
        return this.profileExists;
    }

    /**
     * Set the session from the response of the login request.
     * 
     * @param {Object} response
     * 
     * @return void
     */
    static set(response)
    {
        localStorage.setItem("_profile", JSON.stringify(response));
    }

    /**
     * Delete the session from the local storage.
     * 
     * @return {void}
     */
    static delete()
    {
        localStorage.removeItem("_profile");
        this.profileExists = false;
    }
}

export default Profile;
